import React from "react";

const PhoneIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="22.369" height="22.37" viewBox="0 0 22.369 22.37"><path d="M.812 1.075l4.544-1.049a1.055 1.055 0 0 1 1.2.607l2.1 4.893a1.046 1.046 0 0 1-.3 1.223l-2.651 2.168a16.192 16.192 0 0 0 7.742 7.742l2.167-2.648a1.047 1.047 0 0 1 1.223-.3l4.893 2.1a1.061 1.061 0 0 1 .612 1.206l-1.049 4.544a1.048 1.048 0 0 1-1.022.813 20.27 20.27 0 0 1-20.271-20.274 1.047 1.047 0 0 1 .812-1.025z" transform="translate(0 .001)" fill={props.fill} /></svg>
    )
}

export default PhoneIcon;